import progressConstants from '../constants';

export default {
    /** Resets the progress dialog and hides it */
    hide: () => { return { type: progressConstants.HIDE_PROGRESS }; },

    /** Updates the progress text and ensures the dialog is visible */
    report: (message) => { return { type: progressConstants.REPORT_PROGRESS, message }; }
};